module.exports = __webpack_public_path__ + "img/thumbnail_Moose_m_normal.c93e2237.png";